import { usePostHog } from 'posthog-js/react';
import { SyntheticEvent, useState } from 'react';
import { createSearchParams } from 'react-router-dom';
import { trackAndNavigate } from '../../../Config/libs/analytics';
import { PostHogFeatureFlagEnum } from '../../enum/PostHogEvent.enum';
import { SocialPlatformEnum } from '../../enum/SocialPlatform.enum';

// Key for storing OAuth tracking data in localStorage
export const OAUTH_TRACKING_KEY = 'posthog_oauth_tracking';

export const useSocialRegister = () => {
  const postHog = usePostHog();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleSocialRegister = async (
    _: SyntheticEvent,
    type: SocialPlatformEnum,
  ): Promise<void> => {
    if (isNavigating) return;
    setIsNavigating(true);

    const query = createSearchParams({
      tos_consent: 'true',
      pp_consent: 'true',
      marketing_consent: 'true',
    });

    if (type === SocialPlatformEnum.Google) {
      // Store variant in localStorage before OAuth redirect for tracking after success
      const backgroundVariant = postHog.getFeatureFlag(PostHogFeatureFlagEnum.SignupBackgroundTest);
      localStorage.setItem(
        OAUTH_TRACKING_KEY,
        JSON.stringify({
          variant: backgroundVariant,
          provider: 'google',
          timestamp: Date.now(),
          is_registration: true,
        }),
      );

      trackAndNavigate(
        'register_google_click',
        { event_category: 'User Registration', event_label: 'register_form' },
        () => window.location.assign(`/login/google-oauth2/?${query}`),
      );
    }
  };

  return {
    handleSocialRegister,
    isNavigating,
  };
};
